/**
 * Auto-incrementing sequences for unique test values.
 * Inspired by factory_bot's sequences.
 */

let sequences: Record<string, number> = {};

/**
 * Returns the next value in a named sequence.
 * Each sequence starts at 1 and increments on each call.
 *
 * @example
 * ```ts
 * sequence('user') // 1
 * sequence('user') // 2
 * sequence('document') // 1 (separate sequence)
 * ```
 */
export const sequence = (name: string): number => {
  sequences[name] = (sequences[name] ?? 0) + 1;
  return sequences[name];
};

/**
 * Resets all sequences to 0. Call in beforeEach if tests depend on specific IDs.
 */
export const resetSequences = (): void => {
  sequences = {};
};
